import { render, staticRenderFns } from "./BoatComp.vue?vue&type=template&id=1094af1c&scoped=true"
import script from "./BoatComp.vue?vue&type=script&setup=true&lang=js"
export * from "./BoatComp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BoatComp.vue?vue&type=style&index=0&id=1094af1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094af1c",
  null
  
)

export default component.exports